import React from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  emptyBar: {
    position: 'relative',
    backgroundColor: theme.colors.grayBackground,
    height: (props: Props) =>
      props.barHeight ? props.barHeight : theme.marginBase / 2,
    borderRadius: theme.borderRadius.std,
    zIndex: -1,
    marginTop: theme.marginBase * 2,
  },
  progressBar: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '100%',
    transformOrigin: 'left',
    transform: ({ progression, fullSize }: any) =>
      `scale(${(progression + 1) / fullSize}, 1)`,
    height: (props: Props) =>
      props.barHeight ? props.barHeight : theme.marginBase / 2,
    transition: ({ progression }: Props) =>
      progression === 0 ? '' : `transform .3s ease`,
    borderRadius: theme.borderRadius.std,
    backgroundColor: theme.colors.blue,
  },
}));

interface Props {
  progression: number;
  fullSize: number;
  barHeight?: number;
  className?: string;
}

export const ProgressBar = ({
  progression,
  fullSize,
  barHeight,
  className,
}: Props) => {
  const theme: Theme = useTheme();

  const classes = useStyles({ theme, progression, fullSize, barHeight });
  return (
    <div className={classnames(classes.emptyBar, className)}>
      <span className={classes.progressBar} />
    </div>
  );
};
